import { useContext } from "react";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";

import { signOut } from "firebase/auth";
import { auth } from "../firebase.config";

import Logo from "../assets/mo-logo.webp";
import InternetIcon from "../assets/web.svg";

import { AuthContext } from "../Auth";

const Header = () => {
  const { currentUser } = useContext(AuthContext);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        /* console.log("Signed out"); */
      })
      .catch((error) => {
        console.error(error);
        alert(error.message);
      });
  };

  return (
    <Box
      sx={{
        padding: "15px 30px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <a href="/">
        <img src={Logo} className="logo-md" alt="" />
      </a>
      {currentUser ? (
        <IconButton onClick={handleLogout}>
          <LogoutIcon fontSize="large" />
        </IconButton>
      ) : (
        <a href="https://maxdigital.hr/">
          <img src={InternetIcon} alt="" style={{ width: "2.5rem" }} />
        </a>
      )}
    </Box>
  );
};

export default Header;
